import { onUnmounted, watch, type Ref } from "vue";
import {
  createModalFocusTrap,
  type ModalFocusTrapHandle,
} from "@/utils/modalFocusTrap";

export function useModalFocusTrap(
  containerRef: Ref<HTMLElement | null | undefined>,
  isOpen: () => boolean,
  options: { onEscape?: () => void; closeOnEscape?: boolean } = {},
): void {
  let trap: ModalFocusTrapHandle | null = null;

  const deactivate = () => {
    trap?.deactivate();
    trap = null;
  };

  watch(
    isOpen,
    (open) => {
      deactivate();
      const container = containerRef.value;
      if (!open || !(container instanceof HTMLElement)) return;

      trap = createModalFocusTrap(container, {
        onEscape:
          options.closeOnEscape === false ? undefined : options.onEscape,
      });
      trap.activate();
    },
    { flush: "post", immediate: true },
  );

  onUnmounted(deactivate);
}
